import  {createContext, useEffect} from 'react'
import axios from 'axios';
import UserAPI from './api/UserAPI.js';
import TeamAPI from './api/TeamAPI.js';
import ProjectsAPI from './api/ProjectsAPI.js';
import { dispatchGetUser, dispatchLogin, fetchUser } from './redux/actions/authActions.js';
import { useDispatch, useSelector } from 'react-redux';
// import ProductAPI from './api/ProductAPI.js';
// import CategoriesAPI from './api/CategoriesAPI.js';
import AboutAPI from './api/AboutAPI.js';
import { appAddress } from './App.js';


export const GlobalState = createContext()

export const DataProvider = ({ children }) => {
  // const [token, setToken] = useState(false)
  
    const dispatch = useDispatch()
    const token = useSelector(state => state.token)
    const auth = useSelector(state => state.auth)
    

    useEffect(() => {
      const firstLogin = localStorage.getItem('firstLogin')
      if(firstLogin){
        const getToken = async () => {
          // const res = await axios.post(`${appAddress}/user/refresh_token`, null, {
          const res = await axios.post(`https://api.niadoffice.com/user/refresh_token`, null, {
  withCredentials: true
})
          // const res = await axios.post('/user/refresh_token',  null)

          //  console.log('Global: ', res.data.accesstoken)
          dispatch({type: 'GET_TOKEN', payload: res.data.accesstoken})

          setTimeout(() =>{
            getToken()
          }, 10 * 60 * 1000)
        }
        getToken()
      }
    },[auth.isLogged, dispatch])
  
  
    useEffect(() => {
      if(token){
        const getUser = async () => {
          dispatch(dispatchLogin())
  
          const res = await fetchUser(token);
          dispatch(dispatchGetUser(res));
        }
        getUser()
      }
    },[token, dispatch])

  const state = {
    token: [token],
    // productsAPI: ProductAPI(),
    projectsAPI: ProjectsAPI(),
    // categoriesAPI: CategoriesAPI(),
    userAPI: UserAPI(token),
    aboutUsAPI: AboutAPI(),
    TeamAPI: TeamAPI(),
  }

    return (
      <GlobalState.Provider value={state}>
            {children}
        </GlobalState.Provider>
    )
}